// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"93a33621","170":"3df691ef","190":"0dd88eb8","602":"40b5e7eb","787":"82e7f474"}[chunkId] + ".chunk.js";
};